import { OTCLandingData } from './types'

export const INITIAL_DATA: OTCLandingData = {
  address: '',
  symbol: 'ETH',
  currencies: [],
  rate: undefined,
  precision: 4,
}
